import React from "react";
import { Link } from "react-router-dom";
import "./LegalContent.styles.css";
import { Helmet } from "react-helmet";

const PrivacyPolicyPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className=" cm-legal-content-container">
      <Helmet>
        <title>Globalskyfare | Privacy Policy</title>
      </Helmet>
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">Privacy Policy</h2>
      </div>

      <div className="cm-page-center cm-lr-pad cm-section pb-10">
        <div>
          <h2>Privacy Policy of <a href={`${window.location.origin}`}><b>Globalskyfare.com</b></a>!</h2>

          <p>The privacy of our visitors is one of our top considerations at GlobalSkyFare.Com. The sorts of information that GlobalSkyFare.Com collects and records, as well as how we utilize that information, are detailed in our Privacy Policy document.</p>

          <p>Do not hesitate to contact us at (Email) if you need more information about our Privacy Policy or have any other queries.</p>

          <p>Only our online activities are covered by this privacy statement, which also applies to visitors to our GlobalSkyFare.Com website and the data they provide and/or that we collect there. This policy does not apply to information obtained offline or by means other than this website.</p>
        </div>
        <div>
          <h3><strong>Consent</strong></h3>
          <p>You acknowledge and agree to the terms of our privacy policy when using our website.</p>
        </div>
        <div>
          <h3><strong>Information We Collect</strong></h3>
          <p>When we request your personal information, we shall make it clear to you what personal information we need from you for what purposes.</p>

          <p>If you email us directly, we could get more information about you. This includes your name, email address, phone number, the message and/or attachments you send us, and any other information you want to give us.</p>

          <p>When you create an account, we may request your contact details, such as your name, business name, address, phone number, and email address.</p>
        </div>
        <div>
          <h3><strong>How We Use Your Information?</strong></h3>
          <p>The following are some of the ways we use the data we gather:</p>
          <ul>
            <li>To provide, operate, and maintain our website;</li>
            <li>To improve, personalize, and expand our website;</li>
            <li>To understand and analyze how you use our website,</li>
            <li>To create new features, functionality, services, and goods;</li>
            <li>
              To get in touch with you, either directly or via one of our partners, for customer support purposes;
            </li>
            <li>For the marketing and promotional objectives of this website, as well as to give you updates and other information about it;</li>
            <li>To send you emails and;</li>
            <li>To find and prevent fraud.</li>
          </ul>
        </div>
        <div>
          <h3><strong>Log Files</strong></h3>
          <p>
            GlobalSkyFare.Com uses log files in a conventional manner. These files record visitors' visits when they browse websites.
          </p>
          <p>
            Internet Protocol (IP) addresses, browser type, Internet service provider (ISP), date and time stamp, referring/exit sites, and maybe the number of clicks are among the data gathered by log files.
          </p>
          <p>
            No personally identifying information is linked to them. The information is used for trend analysis, site administration, user movement monitoring, and demographic data collection.
          </p>
        </div>
        <div>
          <h3><strong>Advertising Partners Privacy Policies</strong></h3>
          <p>Log files are used conventionally by GlobalSkyFare.Com. These files document the websites that users visit.</p>
          <p>In their separate ads and links that show up on GlobalSkyFare.Com, third-party AD Servers or AD Networks employ technologies like cookies, web beacons, or JavaScript that are transmitted straight to users' browsers. When this happens, your IP address is immediately sent to them.</p>
          <p>These technologies are used to tailor the advertising material you see on websites you visit and/or gauge their advertising campaigns' success.</p>
          <p>Please note that these cookies are used by third-party advertisers and are not under the control or access of GlobalSkyFare.Com.</p>
        </div>
        <div>
          <h3><strong>Third Party Privacy Policies</strong></h3>

          <p>The privacy statement of GlobalSkyFare.Com does not apply to any websites or advertisers. For more specific information, we thus suggest that you review the corresponding Privacy Policies of these third-party AD Servers. Instructions on how to opt out of particular options and associated practices could be included.</p>
          <p>
            By using your browser's settings, you can decide whether to turn off cookies.
          </p>
          <p>
            You may find detailed information on Cookie Management in the Settings section of each web browser.
          </p>
        </div>
        <div>
          <h3><strong>CCPA Privacy Rights (Do Not Sell My Personal Information)</strong></h3>
          <p>Among other rights under the CCPA, California customers are entitled to:</p>
          <ul>
            <li>
              Demand that a company that gathers customer information reveal the types and particulars of the information that the company has gathered on customers.
            </li>
            <li>
              Ask a company to remove any customer personal information it may have gathered.
            </li>
            <li>
              Request that a firm that sells a consumer's data not sell the consumer's personal data.
            </li>
            <li>
              We have one month from when you submit a request to the time we answer. Please email us at <a href="mailto:info@globalskyfare.com/"><strong>info@globalskyfare.com</strong></a>if you would like to exercise any of these rights.
            </li>
          </ul>
        </div>
        <div>
          <h3><strong>GDPR Data Protection Rights</strong></h3>
          <p>We want to ensure you understand all of your rights regarding data protection. Each user has the following rights:</p>
          <ul>
            <li><strong>The right to access</strong> - You can get copies of your personal information. We charge a small fee for this service.</li>

            <li><strong>The right to rectification</strong> - You are entitled to ask us to update any information you feel is incorrect. Additionally, you can ask us to fill out any information you think is lacking.</li>
            <li><strong>The right to erasure</strong> - Under some circumstances, you have the right to request that we delete your personal information.</li>
            <li><strong>The right to restrict processing</strong> - Under specific circumstances, you have the right to ask that we limit how your personal data is processed.</li>
            <li><strong>The right to object to processing</strong> - Under some circumstances, you have the right to object to how we treat your personal data.</li>
            <li><strong>The right to data portability</strong> - Under some circumstances, you can ask that we provide the information we have gathered to another company or you directly.</li>
          </ul>
          <p>We have one month from when you submit a request to the time we answer. Please email us at <a href="mailto:info@globalskyfare.com/"><strong>info@globalskyfare.com</strong></a>if you would like to exercise any of these rights.</p>
        </div>
        <div>
          <h3><strong>Children's Information</strong></h3>
          <p>Increasing children's online safety is another aspect of our top focus. We urge guardians and parents to watch, engage with, and/or supervise their children's internet behavior.</p>

          <p>Children under thirteen do not intentionally have any personally identifiable information collected by GlobalSkyFare.Com. We kindly ask that you contact us immediately at <a href="mailto:info@globalskyfare.com/"><strong>info@globalskyfare.com</strong></a> if you believe your child submitted this information on our website. We will try to get the material swiftly deleted from our database.</p>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
